import React from "react";
import Loader from "../styles/Loader";

// Suspense fallback for lazily-loaded routes (admin pages, the Pokémon card
// browser). A real loading state — not a blank frame — so a slow connection
// never reads as a broken page. See #69.
const RouteLoadingFallback = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      minHeight: "60vh",
    }}
  >
    <Loader context="panel" label="Loading page" />
  </div>
);

export default RouteLoadingFallback;
